import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const ProjectRow = ({ label, value, dark }) => (
  <div data-testid={`project-detail-${label.toLowerCase().replace(/\s+/g, '-')}`} className={`grid grid-cols-2 ${dark ? 'bg-card' : 'bg-input'}`}>
    <div className="px-4 sm:px-6 py-5 text-[13px] tracking-[0.08em] sm:tracking-[0.18em] uppercase text-accent font-medium break-words">{label}</div>
    <div className="px-4 sm:px-6 py-5 text-[14.5px] text-white/85 border-l border-border break-words">{value}</div>
  </div>
);

export const ProjectInfo = ({ project }) => {
  const rows = [
    ['Tamamlanma Tarihi', project.year], ['Konum', project.location],
    ['Malzeme', project.material], ['Form', project.form],
    ['Kategori', project.category], ['Proje (m²)', project.areaM2.toLocaleString('tr-TR')],
  ];
  return (
    <div className="rounded-2xl overflow-hidden border border-border bg-card h-fit min-w-0">
      <div className="bg-gradient-to-b from-secondary to-card px-7 py-10 border-b border-primary/30">
        <div className="flex items-center gap-3 mb-4"><span className="h-px w-8 bg-clay" /><span className="text-[10.5px] tracking-[0.28em] text-clay font-medium">PROJE DETAYI</span></div>
        <h1 data-testid="project-title" className="text-[26px] sm:text-[32px] lg:text-[36px] leading-[1.15] font-semibold text-white text-center px-2 break-words">{project.title}</h1>
      </div>
      <div className="divide-y divide-white/5">
        {rows.map(([label, value], index) => <ProjectRow key={label} label={label} value={value} dark={index % 2 === 0} />)}
      </div>
      <div className="px-5 sm:px-7 py-7 bg-card border-t border-border">
        <Link data-testid="project-quote-link" to="/iletisim" className="inline-flex items-center justify-center gap-3 w-full px-5 py-4 rounded-full bg-gradient-to-b from-primary to-primary-hover text-primary-foreground text-[12px] font-semibold tracking-[0.1em] sm:tracking-[0.22em] hover:from-primary-hover hover:to-primary-hover transition-colors duration-300 shadow-lg shadow-primary/20">
          BENZER PROJE ICIN TEKLIF ALIN <ArrowRight size={14} className="shrink-0" />
        </Link>
      </div>
    </div>
  );
};